import { Avatar, Button, Card, Col, Divider, Flex, Form, Input, InputNumber, Pagination, Popover, Row, Space, Switch, Tag, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useMemo, useState } from "react";
import FormAntd from "components/form/FormProvide/FormAntd";
import FormItem from "antd/es/form/FormItem";
import { FormInput, FormInputNumber, FormSelect } from "components/form/FormProvide";
import FormSwitch from "components/form/FormProvide/FormSwitch";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import WelfareAddEmployeeModal from "./WelfareAddEmployeeModal";
import WelfareAddPositionModal from "./WelfareAddPositionModal";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "antd/es/form/Form";
import { InfoCircleOutlined } from "@ant-design/icons";
import WelfareAddEmployeeTypeModal from "./WelfareAddEmployeeTypeModal";

const WelfareFrom = ({
  initialValues = {},
  welfareTypeOptions = [],
  employeeTypeOptions = [],
  positionOptions = [],
  periodTimeUnitOptions = [],
  genderOptions = [],
  employeeOptions = [],
  welfareLimitOptions = [],
  welfarePaidOptions = [],
  onSubmit = () => { },
  onCancel = () => { },
  handleCancel = () => { },
  isEmployeeModalOpen = false,
  setIsEmployeeModalOpen = () => { },
  isPositionModalOpen = false,
  setIsPositionModalOpen = () => { },
  selectedEmployees = [],
  selectedPositions = [],
  handleSaveEmployees = () => { },
  handleSavePositions = () => { },
  welfarecategoryOptions = [],
  welfareSubTypeOptions = [],
  recipientOptions = [],
  handleAddPositionIds = () => { },
  employeeByPositionOptions = [],
  onCalculateAsChange = () => { },
  incomeDeductionOptions = [],
  getIncomeOptions = () => { },
  getDeductionOptions = () => { },
  deductionOpt = [],
  incomeOpt = [],
  isEmployeeTypeModalOpen = false,
  setIsEmployeeTypeModalOpen = () => { },
  selectedEmployeeType = [],
  handleSaveEmployeeType = () => { }
}) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = useForm();
  const [ignoreEmployees, setIgnoreEmployees] = useState([]);

  const isCreateMode = location.pathname.includes('/create');

  useEffect(() => {
    if (initialValues && Object.keys(initialValues).length > 0) {
      const values = initialValues;
      form.setFieldsValue(values);
    }
  }, [form, initialValues]);

  const CALCULATE_TYPE_IDS = {
    TYPE_1: "65c0ad74a576190f0fafe865",
    TYPE_2: "65c0adcfa576190f0fafe866",
  };

  useEffect(() => {
    if (initialValues && Object.keys(initialValues).length > 0) {
      form.setFieldsValue(initialValues);
    }
  }, [form, initialValues]);

  const mergedEmployeeData = useMemo(() => {
    const formEmployees = form.getFieldValue("multipleCreditLimitForEmployee") || [];

    const initEmployee = (initialValues?.multipleCreditLimitForEmployee || [])
      .filter((item) => item.employeeId)
      .filter((item) => selectedEmployees.some(emp => emp.id === item.employeeId))
      .map((item) => ({
        employeeId: item.employeeId,
        employeeName: item.employeeName,
        employeeNameEn: item.employeeNameEn,
        numberOfRightPerMonth: item.numberOfRightPerMonth,
        numberOfRightPerYear: item.numberOfRightPerYear,
        numberOfRightPerTime: item.numberOfRightPerTime,
        maximumWithdrawNotLessThan: item.maximumWithdrawNotLessThan,
        percentageOfCreditLimitReceived: item.percentageOfCreditLimitReceived,
      }));

    const modalEmployees = (selectedEmployees || [])
      .filter(emp => !initEmployee.some(backend => backend.employeeId === emp.id))
      .map((emp) => ({
        employeeId: emp.id,
        employeeName: emp.fullname || emp.name,
        employeeNameEn: emp.fullnameEn || emp.nameEn,
        numberOfRightPerMonth: null,
        numberOfRightPerYear: null,
        numberOfRightPerTime: null,
        maximumWithdrawNotLessThan: null,
        percentageOfCreditLimitReceived: null,
      }));

    const combined = [...initEmployee, ...modalEmployees];

    if (formEmployees?.length > 0) {
      return combined.map(emp => {
        const formData = formEmployees.find(f => f.employeeId === emp.employeeId);
        return formData || emp;
      });
    }

    return combined;
  }, [initialValues?.multipleCreditLimitForEmployee, selectedEmployees, form]);

  const mergedPositionData = useMemo(() => {
    const formPositions = form.getFieldValue("multipleCreditLimitForPosition") || [];

    const initPositions = (initialValues?.multipleCreditLimitForPosition || [])
      .filter((item) => item.positionId)
      .filter((item) => selectedPositions.some(pos => pos.id === item.positionId))
      .map((item) => ({
        positionId: item.positionId,
        positionName: item.positionName,
        numberOfRightPerMonth: item.numberOfRightPerMonth,
        numberOfRightPerYear: item.numberOfRightPerYear,
        numberOfRightPerTime: item.numberOfRightPerTime,
        maximumWithdrawNotLessThan: item.maximumWithdrawNotLessThan,
        percentageOfCreditLimitReceived: item.percentageOfCreditLimitReceived,
      }));

    const modalPositions = (selectedPositions || [])
      .filter(pos => !initPositions.some(init => init.positionId === pos.id))
      .map((pos) => ({
        positionId: pos.id,
        positionName: pos.positionName || pos.name,
        numberOfRightPerMonth: null,
        numberOfRightPerYear: null,
        numberOfRightPerTime: null,
        maximumWithdrawNotLessThan: null,
        percentageOfCreditLimitReceived: null,
      }));

    const combined = [...initPositions, ...modalPositions];

    if (formPositions.length > 0) {
      return combined
        .filter(pos => selectedPositions.some(sel => sel.id === pos.positionId))
        .map(pos => {
          const formData = formPositions.find(f => f.positionId === pos.positionId);
          return formData || pos;
        });
    }

    return combined;
  }, [initialValues?.multipleCreditLimitForPosition, selectedPositions, form]);

  useEffect(() => {
    if (mergedEmployeeData.length > 0) {
      const currentFormData = form.getFieldValue("multipleCreditLimitForEmployee") || [];
      if (currentFormData.length !== mergedEmployeeData.length) {
        form.setFieldValue("multipleCreditLimitForEmployee", mergedEmployeeData);
      }
    }
  }, [form, mergedEmployeeData, mergedEmployeeData.length]);

  useEffect(() => {
    if (mergedPositionData.length > 0) {
      const currentFormData = form.getFieldValue("multipleCreditLimitForPosition") || [];
      if (currentFormData.length !== mergedPositionData.length) {
        form.setFieldValue("multipleCreditLimitForPosition", mergedPositionData);
      }
    }
  }, [form, mergedPositionData, mergedPositionData.length]);

  const WelfareLimitFields = ({
    showPerTime = false,
    showMaxWithdraw = false,
    getFieldValue = () => { },
    setFieldValue = () => { }
  }) => {

    const numberParser = (value) => {
      if (!value) return null;
      const cleaned = value.replace(/[^\d.]/g, "");
      const parsed = parseFloat(cleaned);
      if (isNaN(parsed)) return null;
      return String(Math.floor(parsed));
    };

    return (
      <Row gutter={12} wrap>
        <Col flex="1">
          <FormInputNumber
            label={t("welfare.label.number_of_right_per_month")}
            name="numberOfRightPerMonth"
            placeholder={t("unlimited")}
            size="large"
            controls={false}
            precision={0}
            onChange={(val) => {
              const current = getFieldValue("multipleCreditLimit") || {};
              setFieldValue("multipleCreditLimit", {
                ...current,
                numberOfRightPerMonth: val,
              });
            }}
            parser={numberParser}
            dependencies={['numberOfRightPerYear']}
            rules={[
              {
                validator: (_, value) => {
                  const yearValue = getFieldValue("numberOfRightPerYear");
                  if (!value && !yearValue) {
                    return Promise.reject(
                      new Error(t("welfare.label.required_at_least_one"))
                    );
                  }
                  return Promise.resolve();
                }
              }
            ]}
          />
        </Col>
        <Col flex="1">
          <FormInputNumber
            label={t("welfare.label.number_of_right_per_year")}
            name="numberOfRightPerYear"
            placeholder={t("unlimited")}
            size="large"
            controls={false}
            onChange={(val) => {
              const current = getFieldValue("multipleCreditLimit") || {};
              setFieldValue("multipleCreditLimit", {
                ...current,
                numberOfRightPerYear: val,
              });
            }}
            textAlign="right"
            parser={numberParser}
            dependencies={['numberOfRightPerMonth']}
            rules={[
              {
                validator: (_, value) => {
                  const monthValue = getFieldValue("numberOfRightPerMonth");
                  if (!value && !monthValue) {
                    return Promise.reject(
                      new Error(t("welfare.label.required_at_least_one"))
                    );
                  }
                  return Promise.resolve();
                }
              }
            ]}
          />
        </Col>
        {showPerTime && (
          <Col flex="1">
            <FormInputNumber
              label={t("welfare.label.number_of_right_per_time")}
              name="numberOfRightPerTime"
              placeholder={t("unlimited")}
              size="large"
              controls={false}
              onChange={(val) => {
                const current = getFieldValue("multipleCreditLimit") || {};
                setFieldValue("multipleCreditLimit", {
                  ...current,
                  numberOfRightPerTime: val,
                });
              }}
              parser={numberParser}
              textAlign="right"
            />
          </Col>
        )}
        {showMaxWithdraw && (
          <Col flex="1">
            <FormInputNumber
              label={t("welfare.label.maximum_withdraw")}
              name="maximumWithdrawNotLessThan"
              placeholder={t("welfare.label.hundred")}
              size="large"
              controls={false}
              textAlign="right"
              onChange={(val) => {
                const current = getFieldValue("multipleCreditLimit") || {};
                setFieldValue("multipleCreditLimit", {
                  ...current,
                  maximumWithdrawNotLessThan: val,
                });
              }}
              max={100}
              parser={numberParser}
            />
          </Col>
        )}
        <Col flex="1">
          <FormInputNumber
            label={t("welfare.label.percentage_credit_limit")}
            name="percentageOfCreditLimitReceived"
            placeholder={t("welfare.label.hundred")}
            size="large"
            controls={false}
            textAlign="right"
            onChange={(val) => {
              const current = getFieldValue("multipleCreditLimit") || {};
              setFieldValue("multipleCreditLimit", {
                ...current,
                percentageOfCreditLimitReceived: val,
              });
            }}
            max={100}
            parser={numberParser}
          />
        </Col>
      </Row>
    );
  };

  const MultipleCreditLimitRowForEmployee = ({
    item,
    index,
    showPerTime = false,
    showMaxWithdraw = false,
    setFieldValue,
    getFieldValue,
  }) => {
    const form = Form.useFormInstance();
    const isFirstRow = index % 5 === 0;

    const monthFieldName = `numberOfRightPerMonth${item?.employeeId}`;
    const yearFieldName = `numberOfRightPerYear${item?.employeeId}`;

    const updateEmployeeField = async (fieldName, value, shouldValidateBoth = false) => {
      const currentData = getFieldValue("multipleCreditLimitForEmployee") || [];
      const updatedData = currentData.map((employee, idx) => {
        if (idx === index) {
          return { ...employee, [fieldName]: value };
        }
        return employee;
      });
      setFieldValue("multipleCreditLimitForEmployee", updatedData);

      if (shouldValidateBoth) {
        setTimeout(() => {
          form.validateFields([monthFieldName, yearFieldName])
            .then(() => { })
            .catch(() => { });
        }, 0);
      }
    };

    const validateRequiredOne = [
      {
        validator: (_, value) => {
          const monthValue = getFieldValue(monthFieldName);
          const yearValue = getFieldValue(yearFieldName);

          if (monthValue || yearValue) {
            return Promise.resolve();
          }

          return Promise.reject(
            new Error(t("welfare.label.required_at_least_one"))
          );
        },
      },
    ];

    const numberParser = (value) => {
      if (!value) return null;
      const cleaned = value.replace(/[^\d.]/g, "");
      const parsed = parseFloat(cleaned);
      if (isNaN(parsed)) return null;
      return String(Math.floor(parsed));
    };

    return (
      <Row gutter={12} wrap key={item?.employeeId}>
        <Col flex="1">
          <FormInput
            name={`employeeName${item?.employeeId}`}
            label={isFirstRow ? t("employee_list.header") : ""}
            placeholder={t("employee_list.header")}
            size="large"
            disabled
          />
        </Col>

        <Col flex="1">
          <FormInputNumber
            name={monthFieldName}
            label={isFirstRow ? t("welfare.label.number_of_right_per_month") : ""}
            placeholder={t("unlimited")}
            onChange={(val) => updateEmployeeField("numberOfRightPerMonth", val, true)}
            size="large"
            controls={false}
            precision={0}
            parser={numberParser}
            textAlign="right"
            dependencies={[yearFieldName]}
            rules={validateRequiredOne}
          />
        </Col>

        <Col flex="1">
          <FormInputNumber
            name={yearFieldName}
            label={isFirstRow ? t("welfare.label.number_of_right_per_year") : ""}
            placeholder={t("unlimited")}
            onChange={(val) => updateEmployeeField("numberOfRightPerYear", val, true)}
            size="large"
            controls={false}
            parser={numberParser}
            textAlign="right"
            dependencies={[monthFieldName]}
            rules={validateRequiredOne}
          />
        </Col>

        {showPerTime && (
          <Col flex="1">
            <FormInputNumber
              name={`numberOfRightPerTime${item?.employeeId}`}
              label={isFirstRow ? t("welfare.label.number_of_right_per_time") : ""}
              placeholder={t("unlimited")}
              onChange={(val) => updateEmployeeField("numberOfRightPerTime", val, false)}
              size="large"
              controls={false}
              parser={numberParser}
              textAlign="right"
            />
          </Col>
        )}

        {showMaxWithdraw && (
          <Col flex="1">
            <FormInputNumber
              name={`maximumWithdrawNotLessThan${item?.employeeId}`}
              label={isFirstRow ? t("welfare.label.maximum_withdraw") : ""}
              placeholder={t("welfare.label.hundred")}
              onChange={(val) => updateEmployeeField("maximumWithdrawNotLessThan", val, false)}
              size="large"
              controls={false}
              precision={0}
              parser={numberParser}
              textAlign="right"
              max={100}
            />
          </Col>
        )}

        <Col flex="1">
          <FormInputNumber
            name={`percentageOfCreditLimitReceived${item?.employeeId}`}
            label={isFirstRow ? t("welfare.label.percentage_credit_limit") : ""}
            placeholder={t("welfare.label.hundred")}
            onChange={(val) => updateEmployeeField("percentageOfCreditLimitReceived", val, false)}
            size="large"
            controls={false}
            precision={0}
            parser={numberParser}
            textAlign="right"
            max={100}
          />
        </Col>
      </Row>
    );
  };


  const MultipleCreditLimitRowForPosition = ({
    item,
    index,
    showPerTime = false,
    showMaxWithdraw = false,
    setFieldValue,
    getFieldValue
  }) => {
    const form = Form.useFormInstance();
    const isFirstRow = (index % 5) === 0

    const monthFieldName = `numberOfRightPerMonth${item?.positionId}`;
    const yearFieldName = `numberOfRightPerYear${item?.positionId}`;

    const updatePositionField = async (fieldName, value, shouldValidateBoth = false) => {
      const currentData = getFieldValue("multipleCreditLimitForPosition") || [];
      const updatedData = currentData.map((position, idx) => {
        if (idx === index) {
          return { ...position, [fieldName]: value };
        }
        return position;
      });
      setFieldValue("multipleCreditLimitForPosition", updatedData);

      if (shouldValidateBoth) {
        setTimeout(() => {
          form.validateFields([monthFieldName, yearFieldName])
            .then(() => { })
            .catch(() => { });
        }, 0);
      }
    };

    const validateRequiredOne = [
      {
        validator: (_, value) => {
          const monthValue = getFieldValue(monthFieldName);
          const yearValue = getFieldValue(yearFieldName);

          if (monthValue || yearValue) {
            return Promise.resolve();
          }

          return Promise.reject(
            new Error(t("welfare.label.required_at_least_one"))
          );
        },
      },
    ];

    const numberParser = (value) => {
      if (!value) return null;
      const cleaned = value.replace(/[^\d.]/g, "");
      const parsed = parseFloat(cleaned);
      if (isNaN(parsed)) return null;
      return String(Math.floor(parsed));
    };

    return (
      <Row gutter={12} wrap key={`${item?.positionId}`}>
        <Col flex="1">
          <FormInput
            name={`positionName${item?.positionId}`}
            label={isFirstRow ? (t("position.header")) : ""}
            placeholder={t("position.header")}
            size="large"
            disabled
          />
        </Col>

        <Col flex="1">
          <FormInputNumber
            name={monthFieldName}
            label={isFirstRow ? t("welfare.label.number_of_right_per_month") : ""}
            placeholder={t("unlimited")}
            onChange={(val) => updatePositionField("numberOfRightPerMonth", val, true)}
            size="large"
            controls={false}
            precision={0}
            parser={numberParser}
            dependencies={[yearFieldName]}
            rules={validateRequiredOne}
            textAlign="right"
          />
        </Col>

        <Col flex="1">
          <FormInputNumber
            name={[yearFieldName]}
            label={isFirstRow ? t("welfare.label.number_of_right_per_year") : ""}
            placeholder={t("unlimited")}
            onChange={(val) => updatePositionField("numberOfRightPerYear", val, true)}
            size="large"
            controls={false}
            textAlign="right"
            parser={numberParser}
            rules={validateRequiredOne}
          />
        </Col>

        {showPerTime && (
          <Col flex="1">
            <FormInputNumber
              name={`numberOfRightPerTime${item?.positionId}`}
              label={isFirstRow ? t("welfare.label.number_of_right_per_time") : ""}
              placeholder={t("unlimited")}
              onChange={(val) => updatePositionField("numberOfRightPerTime", val, false)}
              size="large"
              controls={false}
              parser={numberParser}
              textAlign="right"
            />
          </Col>
        )}
        {showMaxWithdraw && (
          <Col flex="1">
            <FormInputNumber
              name={`maximumWithdrawNotLessThan${item?.positionId}`}
              label={isFirstRow ? t("welfare.label.maximum_withdraw") : ""}
              placeholder={t("welfare.label.hundred")}
              onChange={(val) => updatePositionField("maximumWithdrawNotLessThan", val, false)}
              size="large"
              controls={false}
              textAlign="right"
              parser={numberParser}
              max={100}
              precision={0}
            />
          </Col>
        )}
        <Col flex="1">
          <FormInputNumber
            name={`percentageOfCreditLimitReceived${item?.positionId}`}
            label={isFirstRow ? t("welfare.label.percentage_credit_limit") : ""}
            placeholder={t("welfare.label.hundred")}
            onChange={(val) => updatePositionField("percentageOfCreditLimitReceived", val, false)}
            size="large"
            controls={false}
            textAlign="right"
            parser={numberParser}
            max={100}
            precision={0}
          />
        </Col>
      </Row>
    );
  };

  const MultipleCreditLimitForAllEmployee = ({
    showPerTime = false,
    showMaxWithdraw = false,
    isAllemployee = false,
    getFieldValue = () => { },
    setFieldValue = () => { }
  }) => {
    const numberParser = (value) => {
      if (!value) return null;
      const cleaned = value.replace(/[^\d.]/g, "");
      const parsed = parseFloat(cleaned);
      if (isNaN(parsed)) return null;
      return String(Math.floor(parsed));
    };

    return (
      <Row gutter={12}>
        <Col flex="1">
          <FormInput
            name="allEmployee"
            label={t("employee.all")}
            placeholder={t("employee.all")}
            size="large"
            disabled
          />
        </Col>
        <Col flex="1">
          <FormInputNumber
            name="numberOfRightPerMonth"
            label={t("welfare.label.number_of_right_per_month")}
            placeholder={t("unlimited")}
            size="large"
            controls={false}
            precision={0}
            parser={numberParser}
            onChange={(val) => {
              const current = getFieldValue("multipleCreditLimit") || {};
              setFieldValue("multipleCreditLimit", {
                ...current,
                numberOfRightPerMonth: val,
              });
            }}
            dependencies={['numberOfRightPerYear']}
            rules={[
              {
                validator: (_, value) => {
                  const yearValue = getFieldValue("numberOfRightPerYear");
                  if (!value && !yearValue) {
                    return Promise.reject(
                      new Error(t("welfare.label.required_at_least_one"))
                    );
                  }
                  return Promise.resolve();
                }
              }
            ]}
          />
        </Col>
        <Col flex="1">
          <FormInputNumber
            name={"numberOfRightPerYear"}
            label={t("welfare.label.number_of_right_per_year")}
            placeholder={t("unlimited")}
            size="large"
            controls={false}
            textAlign="right"
            parser={numberParser}
            onChange={(val) => {
              const current = getFieldValue("multipleCreditLimit") || {};
              setFieldValue("multipleCreditLimit", {
                ...current,
                numberOfRightPerYear: val,
              });
            }}
            dependencies={['numberOfRightPerMonth']}
            rules={[
              {
                validator: (_, value) => {
                  const yearValue = getFieldValue("numberOfRightPerMonth");
                  if (!value && !yearValue) {
                    return Promise.reject(
                      new Error(t("welfare.label.required_at_least_one"))
                    );
                  }
                  return Promise.resolve();
                }
              }
            ]}
          />
        </Col>
        {showPerTime && (
          <Col flex="1">
            <FormInputNumber
              name={"numberOfRightPerTime"}
              label={t("welfare.label.number_of_right_per_time")}
              placeholder={t("unlimited")}
              size="large"
              controls={false}
              textAlign="right"
              onChange={(val) => {
                const current = getFieldValue("multipleCreditLimit") || {};
                setFieldValue("multipleCreditLimit", {
                  ...current,
                  numberOfRightPerTime: val,
                });
              }}
              parser={numberParser}
            />
          </Col>
        )}
        {showMaxWithdraw && (
          <Col flex="1">
            <FormInputNumber
              name={"maximumWithdrawNotLessThan"}
              label={t("welfare.label.maximum_withdraw")}
              placeholder={t("welfare.label.hundred")}
              size="large"
              controls={false}
              textAlign="right"
              onChange={(val) => {
                const current = getFieldValue("multipleCreditLimit") || {};
                setFieldValue("multipleCreditLimit", {
                  ...current,
                  maximumWithdrawNotLessThan: val,
                });
              }}
              max={100}
              parser={numberParser}
            />
          </Col>
        )}
        <Col flex="1">
          <FormInputNumber
            name={"percentageOfCreditLimitReceived"}
            label={t("welfare.label.percentage_credit_limit")}
            placeholder={t("welfare.label.hundred")}
            size="large"
            controls={false}
            textAlign="right"
            onChange={(val) => {
              const current = getFieldValue("multipleCreditLimit") || {};
              setFieldValue("multipleCreditLimit", {
                ...current,
                percentageOfCreditLimitReceived: val,
              });
            }}
            max={100}
            parser={numberParser}
          />
        </Col>
      </Row>
    );
  }

  const MultipleCreditLimitForGeneral = ({
    showPerTime = false,
    showMaxWithdraw = false,
    isAllemployee = false,
    getFieldValue = () => { },
    setFieldValue = () => { }
  }) => {
    const numberParser = (value) => {
      if (!value) return null;
      const cleaned = value.replace(/[^\d.]/g, "");
      const parsed = parseFloat(cleaned);
      if (isNaN(parsed)) return null;
      return String(Math.floor(parsed));
    };

    return (
      <Row gutter={12}>
        <Col flex="1">
          <FormInput
            name="general"
            label={t("employee.label.general")}
            placeholder={t("employee.label.general")}
            size="large"
            disabled
          />
        </Col>
        <Col flex="1">
          <FormInputNumber
            name="generalNumberOfRightPerMonth"
            label={t("welfare.label.number_of_right_per_month")}
            placeholder={t("unlimited")}
            size="large"
            controls={false}
            precision={0}
            parser={numberParser}
            onChange={(val) => {
              const current = getFieldValue("multipleCreditLimitForGeneral") || {};
              setFieldValue("multipleCreditLimitForGeneral", {
                ...current,
                numberOfRightPerMonth: val,
              });

              setFieldValue("generalNumberOfRightPerYear", getFieldValue("generalNumberOfRightPerYear"));
            }}
            dependencies={['generalNumberOfRightPerYear']}
            rules={[
              {
                validator: (_, value) => {
                  const yearValue = getFieldValue("generalNumberOfRightPerYear");
                  if (!value && !yearValue) {
                    return Promise.reject(
                      new Error(t("welfare.label.required_at_least_one"))
                    );
                  }
                  return Promise.resolve();
                }
              }
            ]}
            textAlign="right"
          />
        </Col>
        <Col flex="1">
          <FormInputNumber
            name={"generalNumberOfRightPerYear"}
            label={t("welfare.label.number_of_right_per_year")}
            placeholder={t("unlimited")}
            size="large"
            controls={false}
            textAlign="right"
            parser={numberParser}
            onChange={(val) => {
              const current = getFieldValue("multipleCreditLimitForGeneral") || {};
              setFieldValue("multipleCreditLimitForGeneral", {
                ...current,
                numberOfRightPerYear: val,
              });

              setFieldValue("generalNumberOfRightPerMonth", getFieldValue("generalNumberOfRightPerMonth"));
            }}
            dependencies={['generalNumberOfRightPerMonth']}
            rules={[
              {
                validator: (_, value) => {
                  const yearValue = getFieldValue("generalNumberOfRightPerMonth");
                  if (!value && !yearValue) {
                    return Promise.reject(
                      new Error(t("welfare.label.required_at_least_one"))
                    );
                  }
                  return Promise.resolve();
                }
              }
            ]}
          />
        </Col>
        {showPerTime && (
          <Col flex="1">
            <FormInputNumber
              name={"generalNumberOfRightPerTime"}
              label={t("welfare.label.number_of_right_per_time")}
              placeholder={t("unlimited")}
              size="large"
              controls={false}
              textAlign="right"
              onChange={(val) => {
                const current = getFieldValue("multipleCreditLimitForGeneral") || {};
                setFieldValue("multipleCreditLimitForGeneral", {
                  ...current,
                  numberOfRightPerTime: val,
                });
              }}
              parser={numberParser}
            />
          </Col>
        )}
        {showMaxWithdraw && (
          <Col flex="1">
            <FormInputNumber
              name={"generalMaximumWithdrawNotLessThan"}
              label={t("welfare.label.maximum_withdraw")}
              placeholder={t("welfare.label.hundred")}
              size="large"
              controls={false}
              textAlign="right"
              onChange={(val) => {
                const current = getFieldValue("multipleCreditLimitForGeneral") || {};
                setFieldValue("multipleCreditLimitForGeneral", {
                  ...current,
                  maximumWithdrawNotLessThan: val,
                });
              }}
              max={100}
              parser={numberParser}
            />
          </Col>
        )}
        <Col flex="1">
          <FormInputNumber
            name={"generalPercentageOfCreditLimitReceived"}
            label={t("welfare.label.percentage_credit_limit")}
            placeholder={t("welfare.label.hundred")}
            size="large"
            controls={false}
            textAlign="right"
            onChange={(val) => {
              const current = getFieldValue("multipleCreditLimitForGeneral") || {};
              setFieldValue("multipleCreditLimitForGeneral", {
                ...current,
                percentageOfCreditLimitReceived: val,
              });
            }}
            max={100}
            parser={numberParser}
          />
        </Col>
      </Row>
    );
  }

  const MultipleCreditLimitSection = ({
    getFieldValue,
    setFieldValue,
    mergedEmployeeData,
    mergedPositionData,
    showPerTime,
    showMaxWithdraw,
    onFieldChange,
  }) => {
    const [employeePage, setEmployeePage] = useState(1);
    const [positionPage, setPositionPage] = useState(1);
    const pageSize = 5;

    const hasEmployees = getFieldValue("individualFlag") && (selectedEmployees.length > 0 || mergedEmployeeData.length > 0);
    const hasPositions = getFieldValue("positionFlag") && (selectedPositions.length > 0 || mergedPositionData.length > 0);
    const isGeneralCase = (getFieldValue("conditionFlag") || getFieldValue("yearOfService") ||
      getFieldValue("genderFlag") || getFieldValue("passedProbationFlag")) && !getFieldValue("positionFlag");

    const employeeFormData = getFieldValue("multipleCreditLimitForEmployee") || mergedEmployeeData;
    const positionFormData = getFieldValue("multipleCreditLimitForPosition") || mergedPositionData;

    const paginatedEmployees = useMemo(() => {
      const startIndex = (employeePage - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      return employeeFormData.slice(startIndex, endIndex);
    }, [employeeFormData, employeePage]);

    const paginatedPositions = useMemo(() => {
      const startIndex = (positionPage - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      return positionFormData.slice(startIndex, endIndex);
    }, [positionFormData, positionPage]);

    const getActualIndex = (paginatedIndex, currentPage) => {
      return (currentPage - 1) * pageSize + paginatedIndex;
    };

    useEffect(() => {
      if (employeeFormData.length > 0) {
        const maxPage = Math.ceil(employeeFormData.length / pageSize);
        if (employeePage > maxPage) {
          setEmployeePage(1);
        }
      }
    }, [employeeFormData.length]);

    useEffect(() => {
      if (positionFormData.length > 0) {
        const maxPage = Math.ceil(positionFormData.length / pageSize);
        if (positionPage > maxPage) {
          setPositionPage(1);
        }
      }
    }, [positionFormData.length]);

    return (
      <>
        {/* case all employee */}
        {getFieldValue("allEmployeeFlag") && (
          <MultipleCreditLimitForAllEmployee
            showMaxWithdraw={showMaxWithdraw}
            showPerTime={showPerTime}
            isAllemployee={true}
            getFieldValue={getFieldValue}
            setFieldValue={setFieldValue}
          />
        )}

        {/* case general */}
        {isGeneralCase && (
          <MultipleCreditLimitForGeneral
            showMaxWithdraw={showMaxWithdraw}
            showPerTime={showPerTime}
            isGeneral={true}
            getFieldValue={getFieldValue}
            setFieldValue={setFieldValue}
          />
        )}

        {hasEmployees && (
          <>
            {paginatedEmployees.map((employee, paginatedIndex) => {
              const actualIndex = getActualIndex(paginatedIndex, employeePage);

              return (
                <MultipleCreditLimitRowForEmployee
                  key={employee.employeeId}
                  item={employee}
                  setFieldValue={setFieldValue}
                  getFieldValue={getFieldValue}
                  index={actualIndex}
                  showPerTime={showPerTime}
                  showMaxWithdraw={showMaxWithdraw}
                  onFieldChange={onFieldChange}
                />
              );
            })}

            {mergedEmployeeData.length > pageSize && (
              <Flex justify="center" style={{ marginTop: 16 }}>
                <Pagination
                  current={employeePage}
                  pageSize={pageSize}
                  total={mergedEmployeeData.length}
                  onChange={(page) => setEmployeePage(page)}
                />
              </Flex>
            )}
          </>
        )}

        {hasPositions && (
          <>
            {paginatedPositions?.map((position, paginatedIndex) => {
              const actualIndex = getActualIndex(paginatedIndex, positionPage);

              return (
                <MultipleCreditLimitRowForPosition
                  key={position.positionId}
                  item={position}
                  index={actualIndex}
                  setFieldValue={setFieldValue}
                  getFieldValue={getFieldValue}
                  showPerTime={showPerTime}
                  showMaxWithdraw={showMaxWithdraw}
                  onFieldChange={onFieldChange}
                />
              );
            })}

            {mergedPositionData.length > pageSize && (
              <Flex justify="center" style={{ marginTop: 16 }}>
                <Pagination
                  current={positionPage}
                  pageSize={pageSize}
                  total={mergedPositionData.length}
                  onChange={(page) => setPositionPage(page)}
                />
              </Flex>
            )}
          </>
        )}

        {/* {showDefaultFields && (
          <WelfareLimitFields showPerTime={showPerTime} showMaxWithdraw={showMaxWithdraw} />
        )} */}
      </>
    );
  };

  const handleMultiCreditFieldChange = (item, fieldName, value) => {
    const isEmployee = !!item.employeeId;
    const dataKey = isEmployee ? "mergedEmployeeData" : "mergedPositionData";
    const idKey = isEmployee ? "employeeId" : "positionId";

    const currentData = isEmployee ? mergedEmployeeData : mergedPositionData;
    const updatedData = currentData.map((data) =>
      data[idKey] === item[idKey] ? { ...data, [fieldName]: value } : data
    );

    form.setFieldsValue({
      [dataKey]: updatedData,
    });
  };

  const handleOpenPositionModal = useCallback(async () => {
    setIsPositionModalOpen(true);

    if (selectedPositions && selectedPositions.length > 0) {
      const positionIds = selectedPositions.map(p => p.id);
      const employeeIds = selectedEmployees?.map(e => e.id) || [];
      await handleAddPositionIds(positionIds, employeeIds);
    }
  }, [selectedPositions, selectedEmployees, handleAddPositionIds]);

  const handleOpenEmployeeTypeModal = useCallback(async () => {
    setIsEmployeeTypeModalOpen(true);
  }, [])

  useEffect(() => {
    if (initialValues && Object.keys(initialValues)?.length > 0) {
      const values = initialValues;
      form.setFieldsValue(values);

      if (initialValues?.ignoreEmployees) {
        setIgnoreEmployees(initialValues?.ignoreEmployees);
      }
    }
  }, [form, initialValues]);

  const transformToApiFormat = (values) => {
    const multipleCreditLimit = [];

    if (values.individualFlag && mergedEmployeeData.length > 0) {
      mergedEmployeeData.forEach((emp) => {
        multipleCreditLimit.push({
          employeeId: emp.employeeId,
          maxPerMonth: emp.numberOfRightPerMonth,
          maxPerYear: emp.numberOfRightPerYear,
          maxPerRequest: emp.numberOfRightPerTime,
          maximumWithdrawalIsNotMoreThanTheBaseSalary: emp.maximumWithdrawNotLessThan,
          percentageOfCreditLimitReceived: emp.percentageOfCreditLimitReceived,
        });
      });
    }

    if (values.positionFlag && mergedPositionData.length > 0) {
      mergedPositionData.forEach((pos) => {
        multipleCreditLimit.push({
          positionId: pos.positionId,
          maxPerMonth: pos.numberOfRightPerMonth,
          maxPerYear: pos.numberOfRightPerYear,
          maxPerRequest: pos.numberOfRightPerTime,
          maximumWithdrawalIsNotMoreThanTheBaseSalary: pos.maximumWithdrawNotLessThan,
          percentageOfCreditLimitReceived: pos.percentageOfCreditLimitReceived,
        });
      });
    }

    return {
      ...values,
      multipleCreditLimit: values.multipleCreditLimitFlag ? multipleCreditLimit : [],
      employeeList: values.individualFlag ? selectedEmployees.map((e) => e.id) : [],
      positionList: values.positionFlag ? selectedPositions.map((p) => p.id) : [],
      employeeTypeList: values.employeeTypeFlag ? selectedEmployeeType.map((e) => e.id) : [],
      ignoreEmployees: ignoreEmployees,
    };
  };

  const handleSubmit = (values) => {
    const transformedData = transformToApiFormat(values);
    onSubmit(transformedData);
  };

  const updatedHandleSavePositions = useCallback((positions, newEmployeeIgnoreList = []) => {
    setIgnoreEmployees(newEmployeeIgnoreList);
    handleSavePositions(positions, newEmployeeIgnoreList);
  }, [handleSavePositions]);

  return (
    <FormAntd form={form}
      initialValues={{
        ...initialValues,
        recipient: "68f0aef783032723d4b5bc0c"
      }}
      onFinish={handleSubmit}
    >
      <WelfareAddEmployeeModal
        isEmployeeModalOpen={isEmployeeModalOpen}
        setIsEmployeeModalOpen={setIsEmployeeModalOpen}
        employeeOptions={employeeOptions}
        selectedEmployees={selectedEmployees}
        onSave={handleSaveEmployees}
      />
      <WelfareAddPositionModal
        isPositionModalOpen={isPositionModalOpen}
        setIsPositionModalOpen={setIsPositionModalOpen}
        positionOptions={positionOptions}
        selectedPositions={selectedPositions}
        selectedEmployees={selectedEmployees}
        onSave={updatedHandleSavePositions}
        onAddPositionIds={handleAddPositionIds}
        employeeByPositionOptions={employeeByPositionOptions}
        initialEmployeeIgnoreList={ignoreEmployees}
      />

      <WelfareAddEmployeeTypeModal
        isEmployeeTypeModalOpen={isEmployeeTypeModalOpen}
        setIsEmployeeTypeModalOpen={setIsEmployeeTypeModalOpen}
        employeeTypeOptions={employeeTypeOptions}
        selectedEmployeeType={selectedEmployeeType}
        onSave={handleSaveEmployeeType}
      />

      <FormItem
        shouldUpdate={(prev, curr) => {
          curr["multipleCreditLimitForEmployee"]?.forEach?.((value, index) => {
            curr[`employeeName${value?.employeeId}`] = value?.employeeName
            curr[`numberOfRightPerMonth${value?.employeeId}`] = value?.numberOfRightPerMonth
            curr[`numberOfRightPerYear${value?.employeeId}`] = value?.numberOfRightPerYear
            curr[`maximumWithdrawNotLessThan${value?.employeeId}`] = value?.maximumWithdrawNotLessThan
            curr[`percentageOfCreditLimitReceived${value?.employeeId}`] = value?.percentageOfCreditLimitReceived
            curr[`numberOfRightPerTime${value?.employeeId}`] = value?.numberOfRightPerTime
          })

          curr["multipleCreditLimitForPosition"]?.forEach?.((value, index) => {
            curr[`positionName${value?.positionId}`] = value?.positionName
            curr[`numberOfRightPerMonth${value?.positionId}`] = value?.numberOfRightPerMonth
            curr[`numberOfRightPerYear${value?.positionId}`] = value?.numberOfRightPerYear
            curr[`maximumWithdrawNotLessThan${value?.positionId}`] = value?.maximumWithdrawNotLessThan
            curr[`percentageOfCreditLimitReceived${value?.positionId}`] = value?.percentageOfCreditLimitReceived
            curr[`numberOfRightPerTime${value?.positionId}`] = value?.numberOfRightPerTime
          })

          curr["multipleCreditLimit"]?.forEach?.((value, index) => {
            curr[`numberOfRightPerMonth`] = value?.numberOfRightPerMonth
            curr[`numberOfRightPerYear`] = value?.numberOfRightPerYear
            curr[`numberOfRightPerTime`] = value?.numberOfRightPerTime
            curr[`maximumWithdrawNotLessThan`] = value?.maximumWithdrawNotLessThan
            curr[`percentageOfCreditLimitReceived`] = value?.percentageOfCreditLimitReceived
          })

          return prev.individualFlag !== curr.individualFlag ||
            prev.positionFlag !== curr.positionFlag ||
            prev.yearOfService !== curr.yearOfService ||
            prev.genderFlag !== curr.genderFlag ||
            prev.welfareLimitFlag !== curr.welfareLimitFlag ||
            prev.calculateTypeId !== curr.calculateTypeId ||
            prev.multipleCreditLimitFlag !== curr.multipleCreditLimitFlag ||
            prev.subcategoryId !== curr.subcategoryId ||
            prev.incomeOrDeduct !== curr.incomeOrDeduct ||
            prev.allEmployeeFlag !== curr.allEmployeeFlag ||
            prev.conditionFlag !== curr.conditionFlag ||
            prev.multipleCreditLimitForPosition !== curr.multipleCreditLimitForPosition ||
            prev.multipleCreditLimitForEmployee !== curr.multipleCreditLimitForEmployee ||
            prev.employeeTypeFlag !== curr.employeeTypeFlag
        }}
      >
        {({ getFieldValue, getFieldsValue, resetFields, setFieldValue }) => {
          const calculateTypeId = getFieldValue("calculateTypeId");
          const multipleCreditLimitFlag = getFieldValue("multipleCreditLimitFlag");
          const selectedSubcategoryId = getFieldValue("subcategoryId");

          const selectedSubcategory = welfareSubTypeOptions.find(
            (opt) => opt.id === selectedSubcategoryId
          );

          const isHealth = selectedSubcategory?.code === "WELFARE_SUBCATEGORY_5";
          const isType1 = calculateTypeId === CALCULATE_TYPE_IDS.TYPE_1;
          const isType2 = calculateTypeId === CALCULATE_TYPE_IDS.TYPE_2;
          const shouldShowWelfareLimit = isType1 || isType2;
          const isIncome = getFieldValue("incomeOrDeduct") === "INCOME";
          const isDeduction = getFieldValue("incomeOrDeduct") === "DEDUCTION";

          return (
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
              <Card
                style={{
                  backgroundColor: "white",
                  width: "100%",
                  boxShadow: "0px 4px 2px 0px rgba(0, 0, 0, 0.15)",
                  borderRadius: "20px",
                }}
              >
                <Flex vertical style={{ gap: "24px" }}>
                  <Flex vertical>
                    <span style={{ fontSize: "18px", fontWeight: "bold", color: "#313131" }}>
                      {t("welfare.label.welfare_detail")}
                    </span>
                    <span style={{ color: "#667085" }}>{t("welfare.label.welfare_detail_desc")}</span>
                    <Divider />
                  </Flex>

                  <Row gutter={[0, 16]}>
                    <Col span={12} style={{ paddingRight: 16 }}>
                      <FormInput
                        name="welfareName"
                        label={t("welfare.label.name_th")}
                        placeholder={t("common.please_fill")}
                        size="large"
                        required
                      />
                    </Col>
                    <Col span={12} style={{ paddingLeft: 16 }}>
                      <FormInput
                        name="welfareNameEn"
                        label={t("welfare.label.name_en")}
                        placeholder={t("common.please_fill")}
                        size="large"
                        required
                      />
                    </Col>

                    <Col span={12} style={{ paddingRight: 16 }}>
                      <FormSelect
                        name="categoryId"
                        label={t("welfare.label.category")}
                        placeholder={t("please-select-1")}
                        size="large"
                        options={welfarecategoryOptions}
                        required
                      />
                    </Col>

                    <Col span={12} style={{ paddingLeft: 16 }}>
                      <FormSelect
                        name="subcategoryId"
                        label={t("welfare.label.type")}
                        placeholder={t("please-select-1")}
                        size="large"
                        options={welfareSubTypeOptions}
                        required
                      />
                    </Col>

                    <Col span={12} style={{ paddingRight: 16 }}>
                      <FormSelect
                        name="welfareTypeId"
                        label={t("welfare.label.expense_type")}
                        placeholder={t("please-select-1")}
                        size="large"
                        options={welfareTypeOptions}
                        required
                      />
                    </Col>

                    <Col span={12} style={{ paddingLeft: 16 }}>
                      <FormSelect
                        name="incomeOrDeduct"
                        label={t("welfare.label.income_deduction")}
                        placeholder={t("please-select-1")}
                        size="large"
                        options={[
                          { value: "INCOME", label: t("income.header") },
                          { value: "DEDUCTION", label: t("deduction.header") },
                        ]}
                        onChange={(value) => {
                          form.setFieldValue("incomeDeductionId", undefined);

                          if (value === "INCOME") {
                            getIncomeOptions();
                          } else if (value === "DEDUCTION") {
                            getDeductionOptions();
                          }
                        }}
                        required
                      />
                    </Col>

                    <Flex align="center" style={{ width: "100%" }}>
                      {isHealth && (
                        <Col span={12} style={{ paddingRight: 16 }}>
                          <FormSelect
                            name="recipient"
                            label={t("welfare_list.Select_user_rights")}
                            placeholder={t("please-select-1")}
                            size="large"
                            options={recipientOptions}
                            required
                            disabled
                          />
                        </Col>
                      )}

                      {getFieldValue("incomeOrDeduct") && (
                        <Col span={12} style={{ paddingRight: isHealth ? 0 : 16, paddingLeft: isHealth ? 16 : 0 }}>
                          <FormSelect
                            name="incomeDeductionId"
                            label={isIncome ? t("income.label.type") : isDeduction ? t("deduction.label.type") : null}
                            placeholder={t("please-select-1")}
                            size="large"
                            options={isIncome ? incomeOpt : isDeduction ? deductionOpt : null}
                            required
                          />
                        </Col>
                      )}

                      {!isHealth && (
                        <Col span={12} style={{ paddingLeft: isHealth || getFieldValue("incomeOrDeduct") ? 16 : 0, paddingRight: isHealth ? 0 : 16 }}>
                          <Flex justify="space-between" align="center">
                            <span>{t("welfare.label.cal_benefit_with_salary")}</span>
                            <FormSwitch name="calculateWithPayroll" />
                          </Flex>
                        </Col>)}
                    </Flex>

                    {isHealth && (
                      <Col span={12} style={{ paddingRight: "16px" }}>
                        <Flex justify="space-between" align="center">
                          <span>{t("welfare.label.cal_benefit_with_salary")}</span>
                          <FormSwitch name="calculateWithPayroll" />
                        </Flex>
                      </Col>
                    )}

                    <Col span={24}>
                      <FormInput
                        name="description"
                        label={t("welfare.label.description")}
                        placeholder={t("common.please_fill")}
                        size="large"
                        type="textarea"
                        rows={4}
                      />
                    </Col>
                  </Row>
                </Flex>
              </Card>

              <Card
                style={{
                  backgroundColor: "white",
                  width: "100%",
                  boxShadow: "0px 4px 2px 0px rgba(0, 0, 0, 0.15)",
                  borderRadius: "20px",
                }}
              >
                <Flex vertical style={{ gap: "24px" }}>
                  <Flex vertical>
                    <span style={{ fontSize: "18px", fontWeight: "bold", color: "#313131" }}>
                      {t("welfare.label.conditions_for_receiving")}
                    </span>
                    <span style={{ color: "#667085" }}>{t("welfare.label.conditions_for_receiving_desc")}</span>
                    <Divider />
                  </Flex>

                  <Row gutter={[0, 16]}>
                    <Col span={12} style={{ paddingRight: 16 }}>
                      <Flex justify="space-between" align="center">
                        <span style={{ color: "#565656", fontWeight: "bold" }}>{t("employee.all")}</span>

                        <Flex style={{ textAlign: "end" }}>
                          <FormSwitch
                            name="allEmployeeFlag"
                            dependencies={['conditionFlag']}
                            rules={[
                              {
                                validator: (_, value) => {
                                  if (!isCreateMode) {
                                    const conditionFlag = form.getFieldValue('conditionFlag');
                                    if (!value && !conditionFlag) {
                                      return Promise.reject(
                                        new Error(t("welfare.label.must_select_at_least_one_flag"))
                                      );
                                    }
                                  }
                                  return Promise.resolve();
                                }
                              }
                            ]}
                            onChange={(checked) => {
                              if (checked) {
                                setFieldValue("conditionFlag", null);
                                setFieldValue("positionFlag", null);
                                setFieldValue("yearOfService", null);
                                setFieldValue("genderFlag", null);
                                setFieldValue("passedProbationFlag", null);
                                setFieldValue("individualFlag", null);
                                setFieldValue("attachmentFlag", null);
                              }
                              // Trigger validation for conditionFlag
                              form.validateFields(['conditionFlag']);
                            }}
                            disabled={getFieldValue("conditionFlag")}
                          />
                        </Flex>
                      </Flex>
                    </Col>

                    <Col span={12} style={{ paddingLeft: 16 }}>
                      <Flex justify="space-between" align="center">
                        <span style={{ color: "#565656", fontWeight: "bold" }}>{t("welfare.label.conditional_welfare")}</span>

                        <Flex style={{ textAlign: "end" }}>
                          <FormSwitch
                            name="conditionFlag"
                            dependencies={['allEmployeeFlag']}
                            rules={[
                              {
                                validator: (_, value) => {
                                  if (!isCreateMode) {
                                    const allEmployeeFlag = form.getFieldValue('allEmployeeFlag');
                                    if (!value && !allEmployeeFlag) {
                                      return Promise.reject(
                                        new Error(t("welfare.label.must_select_at_least_one_flag"))
                                      );
                                    }
                                  }
                                  return Promise.resolve();
                                }
                              }
                            ]}
                            onChange={(checked) => {
                              if (checked) {
                                setFieldValue("allEmployeeFlag", null);
                              }
                              // Trigger validation for allEmployeeFlag
                              form.validateFields(['allEmployeeFlag']);
                            }}
                            disabled={getFieldValue("allEmployeeFlag")}
                          />
                        </Flex>
                      </Flex>
                    </Col>
                  </Row>

                  {getFieldValue("conditionFlag") && (
                    <>
                      <Divider style={{ border: "0.5px solid #70C8D4", margin: "0px" }} />

                      <Row gutter={[0, 16]}>
                        <Col span={12} style={{ paddingRight: 16 }}>
                          <Flex vertical gap={16}>
                            <Flex justify="space-between" align="center">
                              <span>{t("employee.label.position")}</span>
                              <FormSwitch
                                name="positionFlag"
                                onChange={(checked) => {
                                  if (!checked) {
                                    setFieldValue("multipleCreditLimitForPosition", []);
                                    handleSavePositions([]);
                                    setIgnoreEmployees([]);
                                  }
                                }}
                              />
                            </Flex>

                            <Flex justify="space-between" align="center">
                              <Col span={17}>
                                {selectedPositions?.length > 0 ? (
                                  (() => {
                                    const MAX_VISIBLE = 10;
                                    const visiblePositions = selectedPositions.slice(0, MAX_VISIBLE);
                                    const hiddenPositions = selectedPositions.slice(MAX_VISIBLE);

                                    return (
                                      <>
                                        {visiblePositions.map((position) => (
                                          <Tag
                                            key={position.id}
                                            style={{
                                              marginBottom: "8px",
                                              backgroundColor: "white",
                                              borderColor: "var(--button-color)",
                                              fontSize: "14px"
                                            }}
                                            bordered={false}
                                          >
                                            <span>
                                              {i18n.language === "en"
                                                ? position.positionNameEn || position.nameEn || "-"
                                                : position.positionName || position.name || "-"}
                                            </span>
                                          </Tag>
                                        ))}

                                        {hiddenPositions.length > 0 && (
                                          <Tooltip
                                            title={
                                              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                                {hiddenPositions.map((position) => (
                                                  <span key={position.id}>
                                                    {i18n.language === "en"
                                                      ? position.positionNameEn || position.nameEn || "-"
                                                      : position.positionName || position.name || "-"}
                                                  </span>
                                                ))}
                                              </div>
                                            }
                                          >
                                            <Tag
                                              style={{
                                                marginBottom: "8px",
                                                backgroundColor: "white",
                                                borderColor: "var(--button-color)",
                                                fontSize: "14px",
                                                cursor: "pointer",
                                              }}
                                              bordered={false}
                                            >
                                              +{hiddenPositions.length}
                                            </Tag>
                                          </Tooltip>
                                        )}
                                      </>
                                    );
                                  })()
                                ) : (
                                  <span style={{ color: "#D9D9D9" }}>{t("welfare.label.pls_add_position")}</span>
                                )}
                              </Col>

                              <Button
                                type="primary"
                                style={{
                                  height: "40px",
                                  borderRadius: "8px",
                                  display: "flex",
                                  alignItems: "center",
                                  backgroundColor: !getFieldValue("positionFlag") ? "" : "var(--button-color)",
                                }}
                                icon={<CreateIcon style={{ fontSize: 16 }} />}
                                disabled={!getFieldValue("positionFlag")}
                                onClick={handleOpenPositionModal}
                              >
                                {t("welfare.label.add_position")}
                              </Button>
                            </Flex>
                          </Flex>
                        </Col>

                        <Col span={12} style={{ paddingLeft: 16 }}>
                          <Flex vertical gap={16}>
                            <Flex justify="space-between" align="center">
                              <span>{t("employee.label.type")}</span>
                              <FormSwitch
                                name="employeeTypeFlag"
                                onChange={(checked) => {
                                  if (!checked) {
                                    handleSaveEmployeeType([]);
                                  }
                                }}
                              />
                            </Flex>

                            <Flex justify="space-between" align="center">
                              <Col span={16}>
                                {selectedEmployeeType?.length > 0 ?
                                  (() => {
                                    const MAX_VISIBLE = 10;
                                    const visibleEmployeeType = selectedEmployeeType.slice(0, MAX_VISIBLE);
                                    const hiddenEmployeeType = selectedEmployeeType.slice(MAX_VISIBLE);

                                    return (
                                      <>
                                        {visibleEmployeeType.map((empType) => (
                                          <Tag
                                            key={empType.id}
                                            style={{
                                              marginBottom: "8px",
                                              backgroundColor: "white",
                                              borderColor: "var(--button-color)",
                                              fontSize: "14px"
                                            }}
                                            bordered={false}
                                          >
                                            <span>
                                              {i18n.language === "en"
                                                ? empType.nameEn || empType.commonTypeNameEn || "-"
                                                : empType.name || empType.commonTypeName || "-"}
                                            </span>
                                          </Tag>
                                        ))}

                                        {hiddenEmployeeType.length > 0 && (
                                          <Tooltip
                                            title={
                                              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                                {hiddenEmployeeType.map((empType) => (
                                                  <span key={empType.id}>
                                                    {i18n.language === "en"
                                                      ? empType.nameEn || empType.commonTypeNameEn || "-"
                                                      : empType.name || empType.commonTypeName || "-"}
                                                  </span>
                                                ))}
                                              </div>
                                            }
                                          >
                                            <Tag
                                              style={{
                                                marginBottom: "8px",
                                                backgroundColor: "white",
                                                borderColor: "var(--button-color)",
                                                fontSize: "14px",
                                                cursor: "pointer",
                                              }}
                                              bordered={false}
                                            >
                                              +{hiddenEmployeeType.length}
                                            </Tag>
                                          </Tooltip>
                                        )}
                                      </>
                                    );
                                  })()
                                  : (
                                    <span style={{ color: "#D9D9D9" }}>{t("welfare.label.pls_add_employee_type")}</span>
                                  )}
                              </Col>

                              <Button
                                type="primary"
                                style={{
                                  height: "40px",
                                  borderRadius: "8px",
                                  display: "flex",
                                  alignItems: "center",
                                  backgroundColor: !getFieldValue("employeeTypeFlag") ? "" : "var(--button-color)",
                                }}
                                icon={<CreateIcon style={{ fontSize: 16 }} />}
                                disabled={!getFieldValue("employeeTypeFlag")}
                                onClick={handleOpenEmployeeTypeModal}
                              >
                                {t("welfare.label.add_employee_type")}
                              </Button>
                            </Flex>
                          </Flex>
                        </Col>
                      </Row>

                      <Row>
                        <Col span={12} style={{ paddingRight: 16 }}>
                          <Flex vertical gap={16}>
                            <Flex justify="space-between" align="center">
                              <span>{t("dashboard.label.year_of_service")}</span>
                              <FormSwitch
                                name="yearOfService"
                                onChange={(checked) => {
                                  if (!checked) {
                                    setFieldValue("year", null);
                                    setFieldValue("month", null);
                                  }
                                }}
                              />
                            </Flex>
                            {getFieldValue("yearOfService") && (
                              <Space.Compact block>
                                <FormItem name="year" noStyle>
                                  <InputNumber
                                    size="large"
                                    placeholder={t("please-enter")}
                                    style={{ width: "100%" }}
                                    controls={false}
                                    suffix={t("unit.year")}
                                  />
                                </FormItem>
                                <FormItem name="month" noStyle>
                                  <InputNumber
                                    size="large"
                                    placeholder={t("please-enter")}
                                    style={{ width: "100%" }}
                                    controls={false}
                                    suffix={t("unit.month")}
                                    max={11}
                                  />
                                </FormItem>
                              </Space.Compact>
                            )}
                          </Flex>
                        </Col>

                        <Col span={12} style={{ paddingLeft: 16 }}>
                          <Flex vertical gap={16}>
                            <Flex justify="space-between" align="center">
                              <span>{t("employee.gender")}</span>
                              <FormSwitch
                                name="genderFlag"
                                onChange={(checked) => {
                                  if (!checked) {
                                    setFieldValue("genderId", null);
                                  }
                                }}
                              />
                            </Flex>
                            {getFieldValue("genderFlag") && (
                              <FormSelect
                                name="genderId"
                                size="large"
                                placeholder={t("common.pleaseSelect")}
                                options={genderOptions}
                              />
                            )}
                          </Flex>
                        </Col>
                      </Row>

                      <Row>
                        <Col span={12} style={{ paddingRight: 16 }}>
                          <Flex justify="space-between" align="center">
                            <span>{t("welfare.label.passed_probation")}</span>
                            <FormSwitch name="passedProbationFlag" />
                          </Flex>
                        </Col>
                      </Row>

                      <Divider style={{ border: "0.5px solid #70C8D4", margin: "0px" }} />

                      <Row>
                        <Col span={12} style={{ paddingRight: 16 }}>
                          <Flex vertical gap={16}>
                            <Flex justify="space-between" align="center">
                              <span>{t("welfare.label.Individual")}</span>
                              <FormSwitch
                                name="individualFlag"
                                onChange={(checked) => {
                                  if (!checked) {
                                    setFieldValue("multipleCreditLimitForEmployee", []);
                                    handleSaveEmployees([]);
                                  }
                                }}
                              />
                            </Flex>

                            <Flex justify="space-between" align="center">
                              {selectedEmployees?.length > 0 ? (
                                <Avatar.Group maxCount={5} maxStyle={{ color: "#2CADE7", backgroundColor: "#ECECEC" }}>
                                  {selectedEmployees.map((employee) => (
                                    <Tooltip
                                      key={employee.id}
                                      title={
                                        i18n.language === "en"
                                          ? employee.nameEn || employee.fullnameEn || "-"
                                          : employee.name || employee.fullname || "-"
                                      }
                                    >
                                      <Avatar key={employee.id}>{i18n.language === "en"
                                        ? employee.nameEn?.charAt(0) || employee.fullnameEn?.charAt(0)
                                        : employee.name?.charAt(0) || employee.fullname?.charAt(0)}
                                      </Avatar>
                                    </Tooltip>
                                  ))}
                                </Avatar.Group>
                              ) : (
                                <span style={{ color: "#D9D9D9" }}>{t("welfare.label.pls_add_employee")}</span>
                              )}

                              <Button
                                type="primary"
                                style={{
                                  height: "40px",
                                  borderRadius: "8px",
                                  display: "flex",
                                  alignItems: "center",
                                  backgroundColor: !getFieldValue("individualFlag") ? "" : "var(--button-color)",
                                }}
                                icon={<CreateIcon style={{ fontSize: 16 }} />}
                                disabled={!getFieldValue("individualFlag")}
                                onClick={() => setIsEmployeeModalOpen(true)}
                              >
                                {t("employee.label.add")}
                              </Button>
                            </Flex>
                          </Flex>
                        </Col>
                      </Row>

                      <Divider style={{ border: "0.5px solid #70C8D4", margin: "0px" }} />

                      <Row>
                        <Col span={12} style={{ paddingRight: 16 }}>
                          <Flex justify="space-between" align="center">
                            <span>{t("news.label.attachment")}</span>
                            <FormSwitch name="attachmentFlag" />
                          </Flex>
                        </Col>
                        <Col span={12} style={{ paddingLeft: 16 }}>
                          <Flex justify="space-between" align="center">
                            <span>{t("welfare.label.same_day")}</span>
                            <FormSwitch name="sameDayFlag" />
                          </Flex>
                        </Col>
                      </Row>
                    </>
                  )}
                </Flex>
              </Card>

              <Card
                style={{
                  backgroundColor: "white",
                  width: "100%",
                  boxShadow: "0px 4px 2px 0px rgba(0, 0, 0, 0.15)",
                  borderRadius: "20px",
                }}
              >
                <Flex vertical style={{ gap: "24px" }}>
                  <Flex vertical>
                    <Flex justify="space-between">
                      <span style={{ fontSize: "18px", fontWeight: "bold", color: "#313131" }}>
                        {t("welfare.label.set_the_welfare_limit")}
                      </span>
                      <FormSwitch name="welfareLimitFlag" />
                    </Flex>
                    <span style={{ color: "#667085" }}>{t("welfare.label.set_the_welfare_limit_desc")}</span>
                    <Divider />
                  </Flex>

                  {getFieldValue("welfareLimitFlag") && (
                    <Flex vertical style={{ gap: "24px" }}>
                      <Row>
                        <Col span={12} style={{ paddingRight: 16 }}>
                          <FormSelect
                            name="calculateTypeId"
                            label={t("welfare.label.calculate_limit")}
                            required
                            size="large"
                            options={welfareLimitOptions}
                          />
                        </Col>
                      </Row>

                      <Row>
                        <Col span={12} style={{ paddingRight: 16 }}>
                          <Flex justify="space-between" align="center">
                            <Flex gap={8}>
                              <span>{t("welfare.label.set_mutiple_limit")}</span>
                              <Popover content={t("employee.label.welfare_multi_desc")} trigger="hover">
                                <InfoCircleOutlined style={{ color: "#D9D9D9" }} />
                              </Popover>
                            </Flex>
                            <FormSwitch name="multipleCreditLimitFlag"
                              disabled={
                                !getFieldValue("calculateTypeId")
                              }
                            />
                          </Flex>
                        </Col>
                      </Row>

                      {shouldShowWelfareLimit && (
                        <>
                          <Divider style={{ border: "0.5px solid #70C8D4", margin: "0px" }} />

                          {multipleCreditLimitFlag ? (
                            // เปิด toggle
                            <MultipleCreditLimitSection
                              getFieldValue={getFieldValue}
                              getFieldsValue={getFieldsValue}
                              setFieldValue={setFieldValue}
                              mergedEmployeeData={mergedEmployeeData}
                              mergedPositionData={mergedPositionData}
                              showPerTime={isType2}
                              showMaxWithdraw={isType1}
                              onFieldChange={handleMultiCreditFieldChange}
                            />
                          ) : (
                            // ปิด Toggle
                            <WelfareLimitFields
                              showPerTime={isType2}
                              showMaxWithdraw={isType1}
                              getFieldValue={getFieldValue}
                              setFieldValue={setFieldValue}
                            />
                          )}
                        </>
                      )}
                    </Flex>
                  )}
                </Flex>
              </Card>

              <Row justify="end" style={{ gap: "8px" }}>
                <Button
                  type="default"
                  size="large"
                  onClick={() => {
                    resetFields();
                    navigate("/configuration/payroll", { state: { selectedTab: 'welfare' } });
                  }}
                >
                  {t("common.cancel")}
                </Button>

                <Button
                  type="primary"
                  style={{ backgroundColor: "var(--button-color)" }}
                  size="large"
                  htmlType="submit"
                >
                  {t("common.save")}
                </Button>
              </Row>
            </Space>
          );
        }}
      </FormItem>
    </FormAntd>
  );
};

export default WelfareFrom;